<template>
  <header class="app-header">
    <div class="container">
      <router-link to="/" class="logo-link">
        <img src="@/assets/Repaek_LOGO.png" alt="RE Peak Logo" class="logo" />

        <span class="company-name">RE Peak(HK) Co.,Limited </span>
      </router-link>
      <button
        class="menu-toggle"
        type="button"
        @click="toggleMobileMenu"
        aria-label="Toggle navigation"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <nav class="desktop-nav">
        <ul>
          <li v-for="item in navItems" :key="item.key">
            <a
              v-if="item.key === 'contact'"
              href="#"
              @click.prevent="openContactModal"
            >
              {{ item.name }}
            </a>
            <a
              v-else-if="item.isExternal || item.link.startsWith('#')"
              :href="item.link"
              @click="
                item.link.startsWith('#') && item.link.length > 1
                  ? navigateToSection($event, item.link)
                  : null
              "
              :target="item.isExternal ? '_blank' : null"
            >
              {{ item.name }}
            </a>
            <router-link v-else :to="item.link">{{ item.name }}</router-link>
          </li>
          <li class="nav-dropdown">
            <span
              class="nav-dropdown-trigger"
              :class="{ active: isLegalRouteActive }"
            >
              {{ $t("header.nav.legal") }}
              <span class="dropdown-caret">▾</span>
            </span>
            <ul class="dropdown-menu">
              <li v-for="item in legalNavItems" :key="item.key">
                <router-link :to="item.link">
                  {{ item.name }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <div class="header-actions">
        <button @click="switchLanguage" class="lang-switcher">
          <!-- 假设你使用根据当前语言显示不同提示图标的方案 -->
          <!-- <img v-if="$i18n.locale === 'zh'" src="@/assets/icons/earth-icon-en.svg" alt="Switch to English" class="lang-icon" />
          <img v-else src="@/assets/icons/earth-icon-zh.svg" alt="切换到中文" class="lang-icon" /> -->
          <!-- 如果只有一个通用图标，使用下面这行并注释掉上面两行 -->
          <!-- <img src="@/assets/icons/global-language-icon.svg" alt="Language" class="lang-icon" /> -->
          <span class="lang-text">{{ $t("header.langSwitchTo") }}</span>
        </button>
      </div>
    </div>
    <!-- 移动端折叠菜单 -->
    <nav v-if="isMobileMenuOpen" class="mobile-nav">
      <ul>
        <li v-for="item in navItems" :key="item.key" @click="closeMobileMenu">
          <a
            v-if="item.key === 'contact'"
            href="#"
            @click.prevent="openContactModal"
          >
            {{ item.name }}
          </a>
          <a
            v-else-if="item.isExternal || item.link.startsWith('#')"
            :href="item.link"
            @click="
              item.link.startsWith('#') && item.link.length > 1
                ? navigateToSection($event, item.link)
                : null
            "
            :target="item.isExternal ? '_blank' : null"
          >
            {{ item.name }}
          </a>
          <router-link v-else :to="item.link">{{ item.name }}</router-link>
        </li>
        <li class="mobile-legal-group">
          <button
            type="button"
            class="mobile-legal-trigger"
            @click="toggleLegalSubmenu"
          >
            {{ $t("header.nav.legal") }}
            <span class="dropdown-caret">{{
              isLegalSubmenuOpen ? "▴" : "▾"
            }}</span>
          </button>
          <ul v-if="isLegalSubmenuOpen" class="mobile-legal-submenu">
            <li
              v-for="item in legalNavItems"
              :key="item.key"
              @click="closeMobileMenu"
            >
              <router-link :to="item.link">{{ item.name }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <ContactFormModal
      :show="isContactModalVisible"
      @close="closeContactModal"
    />
  </header>
</template>

<script>
import ContactFormModal from "@/components/ContactFormModal.vue";

export default {
  name: "AppHeader",
  components: {
    ContactFormModal,
  },
  data() {
    return {
      isContactModalVisible: false,
      isMobileMenuOpen: false,
      isLegalSubmenuOpen: false,
    };
  },
  computed: {
    navItems() {
      return [
        { key: "home", name: this.$t("header.nav.home"), link: "/" },
        { key: "about", name: this.$t("header.nav.about"), link: "/about" },
        {
          key: "solutions",
          name: this.$t("header.nav.solutions"),
          link: "/major-media",
        },
        {
          key: "account",
          name: this.$t("header.nav.account"),
          link: "/account-service",
        },
        {
          key: "products",
          name: this.$t("header.nav.products"),
          link: "/major-media-services",
        },
        { key: "contact", name: this.$t("header.nav.contact"), link: "#" },
      ];
    },
    legalNavItems() {
      return [
        {
          key: "terms",
          name: this.$t("header.nav.legalDropdown.terms"),
          link: "/legal/terms-and-policies",
        },
        {
          key: "privacy",
          name: this.$t("header.nav.legalDropdown.privacy"),
          link: "/legal/privacy-policy",
        },
        {
          key: "legalInfo",
          name: this.$t("header.nav.legalDropdown.legalInfo"),
          link: "/legal/legal-information",
        },
      ];
    },
    isLegalRouteActive() {
      return this.$route.path.startsWith("/legal");
    },
  },
  methods: {
    switchLanguage() {
      const newLocale = this.$i18n.locale === "zh" ? "en" : "zh";
      this.$i18n.locale = newLocale;
      localStorage.setItem("userLanguage", newLocale);
    },
    openContactModal() {
      this.isContactModalVisible = true;
    },
    closeContactModal() {
      this.isContactModalVisible = false;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      this.isLegalSubmenuOpen = false;
    },
    toggleLegalSubmenu() {
      this.isLegalSubmenuOpen = !this.isLegalSubmenuOpen;
    },
    navigateToSection(event, sectionIdWithPossiblePath) {
      event.preventDefault();
      const parts = sectionIdWithPossiblePath.split("#");
      const path = parts[0];
      const sectionId = parts[1] ? `#${parts[1]}` : null;

      const navigateAndScroll = () => {
        if (sectionId) {
          this.$nextTick(() => {
            const element = document.querySelector(sectionId);
            if (element) {
              element.scrollIntoView({ behavior: "smooth", block: "start" });
            } else {
              console.warn(`未找到元素: ${sectionId}`);
            }
          });
        } else if (path === "/") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      };

      if (path && this.$route.path !== path) {
        this.$router
          .push(path)
          .then(navigateAndScroll)
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            } else {
              navigateAndScroll();
            }
          });
      } else {
        navigateAndScroll();
      }
    },
  },
};
</script>

<style scoped>
.logo-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  line-height: 1;
}
.app-header {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 15px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
  transition: all 0.3s ease;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 40px;
  flex-shrink: 0;
}

.company-name {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.desktop-nav > ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.desktop-nav > ul > li {
  margin-left: 25px;
  display: flex;
  align-items: center;
}

.desktop-nav a,
.desktop-nav .router-link-active,
.desktop-nav .router-link-exact-active,
.nav-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: #1a1a2e;
  font-weight: 500;
  font-size: 1.05rem;
  line-height: 1.5;
  padding: 5px 0;
  border-bottom: 2px solid transparent;
  box-sizing: border-box;
  transition: color 0.3s ease, transform 0.2s ease;
  cursor: pointer;
}

.desktop-nav a:hover,
.desktop-nav .router-link-active:hover,
.desktop-nav .router-link-exact-active:hover,
.nav-dropdown-trigger:hover {
  color: #007bff;
  transform: translateY(-1px);
}

.desktop-nav .router-link-exact-active,
.nav-dropdown-trigger.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.nav-dropdown {
  position: relative;
}

.nav-dropdown-trigger {
  user-select: none;
  gap: 4px;
}

.dropdown-caret {
  font-size: 0.65rem;
  line-height: 1;
  margin-top: 1px;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  display: none;
  min-width: 200px;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 1100;
}

.nav-dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu::before {
  content: "";
  position: absolute;
  top: -8px;
  left: 0;
  width: 100%;
  height: 8px;
}

.dropdown-menu li {
  margin: 0;
  display: block;
}

.dropdown-menu a,
.dropdown-menu .router-link-active,
.dropdown-menu .router-link-exact-active {
  display: block;
  padding: 10px 20px;
  text-decoration: none;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  border-bottom: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.dropdown-menu a:hover,
.dropdown-menu .router-link-active:hover,
.dropdown-menu .router-link-exact-active:hover {
  background-color: #f0f7ff;
  color: #007bff;
}

.dropdown-menu .router-link-exact-active {
  color: #007bff;
  background-color: #f0f7ff;
  border-bottom: none;
}

.header-actions {
  display: flex;
  align-items: center;
}

.lang-switcher {
  display: inline-flex;
  align-items: center;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  padding: 8px 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  white-space: nowrap;
}

.lang-switcher:hover {
  background-color: #e9ecef;
  border-color: #ced4da;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.lang-switcher:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.lang-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px;
  vertical-align: middle;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  margin-left: auto;
  margin-right: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.menu-toggle span {
  width: 22px;
  height: 2px;
  background-color: #333;
  border-radius: 1px;
  margin: 3px 0;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.mobile-nav {
  display: none;
}

.mobile-nav ul {
  list-style: none;
  margin: 0;
  padding: 10px 20px 16px;
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
}

.mobile-nav li {
  padding: 8px 0;
}

.mobile-nav a,
.mobile-nav .router-link-active,
.mobile-nav .router-link-exact-active {
  text-decoration: none;
  color: #333;
  font-weight: 500;
}

.mobile-nav .router-link-exact-active {
  color: #007bff;
}

.mobile-legal-group {
  padding: 8px 0;
}

.mobile-legal-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: #333;
  font-weight: 500;
  font-size: 1rem;
  font-family: inherit;
  cursor: pointer;
}

.mobile-legal-submenu {
  list-style: none;
  margin: 8px 0 0;
  padding: 0 0 0 16px;
}

.mobile-legal-submenu li {
  padding: 6px 0;
}

@media (max-width: 768px) {
  .company-name {
    font-size: 0.75rem;
    max-width: 140px;
    white-space: normal;
    line-height: 1.2;
  }

  .desktop-nav {
    display: none;
  }
  .menu-toggle {
    display: flex;
  }
  .mobile-nav {
    display: block;
  }
}
</style>
